import React, { useRef, useContext } from "react";
import paper from "../../assets/paper.png";
import pencil from "../../assets/pencil.png";
import trash from "../../assets/trash.png";
import moment from "moment/moment";
import message from "../../assets/message.png";
import printer from "../../assets/Printer.png";
import pdf from "../../assets/pdf.png";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import CurrencyFormat from "react-currency-format";
import { invoiceService } from "../../services/invoice.service";
import { Grid } from "@mui/material";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import InvoiceScroll from "../InvoiceScroll";
import InvoicePaymentTable from "./InvoicePaymentTable";
import InvoiceDetailsTable from "./InvoiceDetailsTable";
import { SetInvoiceEdit, SetInvoiceData, GetInvoiceData} from "../../store/invoiceAtom";
import LogicContext from "../../Context/LogicContext";
import { ImAttachment } from "react-icons/im";
import { FaFilePdf } from "react-icons/fa";
import { MdDelete, MdEdit } from "react-icons/md";
import { IoPrintSharp } from "react-icons/io5";
import StatusBadge from "../../generals/StatusBadge";

const InvoiceDetailsPage = () => {
  const setEdit = SetInvoiceEdit();
  const setInvoiceData = SetInvoiceData();
  const getInvoiceData = GetInvoiceData();
  const [selectedList, setSelectedList] = useState([]);
  const myPromiseModal = createModal(GeneralModal);
  const { invoice_id } = useParams();
  const navigate = useNavigate();
  const logicContext = useContext(LogicContext);
  const [invoice, setInvoice] = useState({});
  const { pathname } = useLocation();
  var url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];

  // Ref for the main invoice details div (the one we want to print)
  const invoiceDetailsRef = useRef();

  // Print handler
  const handlePrint = () => {
    window.print();
  };

  const handleDownloadPdf = async () => {
    const result = await myPromiseModal({
      title: "Download PDF",
      body: `Do you want to download ${invoice?.Invoice_No || "this invoice"} as PDF?`,
      showInput: false,
      placeHolder: "",
    });
    if (result.decision !== true) return;

    try {
      const response = await invoiceService.downloadInvoicePdf(invoice_id);
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Invoice-${invoice?.Invoice_No || invoice_id}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (err) {
      logicContext.showToast("Unable to download PDF", "error");
    }
  };

  useEffect(() => {
    getInvoiceDetails(invoice_id);
  }, [invoice_id]);

  const getInvoiceDetails = async (id) => {
    const response = await invoiceService.getInvoiceDetails(id);
    if (response?.data) {
      setInvoice(response.data);
    }
  };

  function viewItemDetails(id) {
    navigate(
      `/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}`
    );
  }

  function viewPaymentRecord(id) {
    navigate(
      `/${currModuleId}/${currModuleName}/payment-received/details/${id}`
    );
    getInvoiceDetails(id);
  }

  const editCurrentInvoice = async () => {
    const response = await myPromiseModal({
      title: "Modify Invoice",
      body: " Do you want to modify this record?",
      showInput: false,
      placeHolder: "",
    });
    if (response.decision === true) {
      setEdit(invoice);
      navigate(
        `/${currModuleId}/${currModuleName}/${currUserMenu}/add-invoice`
      );
    }
  };

  function onSelection(list) {
    let tempList = list?.filter((item) => item.checked === true);
    setSelectedList(tempList);
  }

  const removeDeletedInvoice = (refNum) => {
    let newList = getInvoiceData?.invoice_info?.filter(
      (invoice) => invoice.Invoice_Ref_No !== refNum
    );
    setInvoiceData({...getInvoiceData, invoice_info: newList});
  };

  const deleteInvoice = async () => {
    await myPromiseModal({
      title: "confirm your Delete!",
      body: `Do you want to delete ${invoice?.Invoice_No} ?`,
      showInput: false,
      placeHolder: "",
    }).then((response) => {
      if (response.decision === true) {
        let option = 4;
        let temp = `<a> <refno> ${invoice.Invoice_Ref_No} </refno> </a>`;
        let xml_string_refno = `<root> ${temp} </root>`;

        invoiceService.invoiceBulkAction({ xml_string_refno, option }).then((res) => {
          if (res?.data !== undefined) {
            const { message_text } = res.data[0];
            logicContext.showToast(message_text, "success");
            navigate(-1);
            return removeDeletedInvoice(invoice.Invoice_Ref_No);
          }
        })
        .catch((err) => {
          logicContext.showToast("Error", "error");
        });
      }
    });
  };

  async function bulkActions(action) {
    var currDisplayItem = false;
    await myPromiseModal({
      title: "confirm your action!",
      body: `Do you want to ${action.Action_Name} ?`,
      showInput: false,
      placeHolder: "",
    }).then((result) => {
      if (result.decision === true) {
        let temp = "";
        const option = action.Procedure_Option;
        selectedList.map((item) => {
          if (item.Invoice_Ref_No == invoice_id) {
            currDisplayItem = true;
          } else {
            currDisplayItem = false;
          }
          temp += `<a> <refno> ${item.Invoice_Ref_No} </refno> </a>`;
        });

        let xml_string_refno = `<root> ${temp} </root>`;

        invoiceService.invoiceBulkAction({ xml_string_refno, option }).then((res) => {
          if (res?.data !== undefined) {
            const { message_text } = res.data[0];
            logicContext.showToast(message_text, "success");
            if (currDisplayItem === true) {
              getInvoiceDetails(invoice_id);
            }
            return reloadInvoiceData();
          }
        })
        .catch((err) => {
          logicContext.showToast("Error", "error");
        });
      }
    });
  }

  const reloadInvoiceData = async () => {
    try {
      const response = await invoiceService.getInvoiceData();
      if (response?.data !== undefined) {
        setInvoiceData(response.data);
      }
    } catch (error) {
      logicContext.showToast("connection error getting invoice data", "error");
    }
  };

  const calculateSubTotal = (list) => {
    let result = 0;
    list?.map((item) => {
      result += item.Item_Sales_Rate * item?.Item_Sales_Quantity;
    });
    return result;
  };

  const calculateGrandTotal = (list) => {
    let grandTotal = 0;
    list?.map((item) => {
      grandTotal += item.Item_Sales_Rate * item?.Item_Sales_Quantity;
    });

    grandTotal = grandTotal - invoice?.Discount_Amount;
    grandTotal = grandTotal + invoice?.Shipping_Amount;
    grandTotal = grandTotal + invoice?.Adjustment_Amount;
    if (invoice?.Discount_Type_Id === 2) {
      let temDiscount = (invoice?.Discount_Amount / 100) * grandTotal;
      grandTotal = grandTotal - temDiscount;
      return grandTotal;
    } else {
      return grandTotal;
    }
  };

  const calculatePayment = (list) => {
    let grandTotal = 0;
    list?.map((item) => {
      grandTotal += item.Payment_Amount;
    });
    return grandTotal;
  };

  async function recordPayment() {
    await myPromiseModal({
      title: "Record Payment!",
      body: `Record Payment for ${invoice?.Invoice_No} ?`,
      showInput: false,
      placeHolder: "",
    }).then((response) => {
      if (response.decision === true) {
        navigate(
          `/${currModuleId}/${currModuleName}/${"payment-received"}/add-new?Customer_Id=${
            invoice?.Customer_Id
          }&Customer_Full_Name=${
            invoice?.Customer_Full_Name
          }&Invoice_Ref_No=${invoice?.Invoice_Ref_No}`
        );
      }
    });
  }

  return (
    <>
      {/* Print styles - only show the main invoice details */}
      <style>{`
        @media print {
          /* Hide everything by default */
          body * {
            visibility: hidden;
          }
          /* Show only the invoice details container and its children */
          .print-invoice, .print-invoice * {
            visibility: visible;
          }
          /* Position it at the top left */
          .print-invoice {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            margin: 0;
            padding: 0.2in;
            background: white;
            font-size: 10pt;
          }
          /* Remove extra backgrounds, shadows, and borders */
          .print-invoice * {
            background: transparent !important;
            box-shadow: none !important;
            border-color: #ccc !important;
          }
          /* Adjust table font size */
          table, .MuiGrid-root {
            font-size: 9pt;
          }
          /* Ensure no page breaks inside the invoice */
          .print-invoice {
            page-break-inside: avoid;
          }
          /* Set page margins */
          @page {
            margin: 0.3in;
          }
          /* Make links black */
          a {
            color: black;
            text-decoration: none;
          }
        }
      `}</style>

      <section className="">
        {/* Bulk actions & buttons - hidden when printing (they are outside .print-invoice) */}
        <section className="flex flex-wrap justify-between">
          <div className="mt-3">
            {selectedList.length > 0 && (
              <Dropdown>
                <Dropdown.Toggle
                  className="border-[1px] border-gray-200"
                  style={{
                    backgroundColor: "#FFFFFF",
                    color: "#45444B",
                    fontSize: "12px",
                    height: "40px",
                  }}
                  id="dropdown-basic"
                >
                  Bulk Actions
                </Dropdown.Toggle>

                <Dropdown.Menu className="w-32 px-2 text-sm shadow-lg">
                  {getInvoiceData?.bulk_action?.map((action, i) => {
                    return (
                      <Dropdown.Item
                        className="px-0 text-gray-600"
                        key={i}
                        onClick={() => bulkActions(action)}
                      >
                        {action.Action_Name}
                      </Dropdown.Item>
                    );
                  })}
                </Dropdown.Menu>
              </Dropdown>
            )}
          </div>

          <div className="flex flex-row flex-wrap items-center">
            <div className="mt-3 flex flex-row items-center mr-6">
              <button
                type="button"
                onClick={() => recordPayment(2)}
                className="w-fit px-6 py-2.5 text-sm font-semibold bg-[#486EF8] tracking-widest outline-none rounded-lg text-white hover:bg-[#486EF8]/80 active:bg-[#486EF8] transition-all duration-300 active:outline-none"
              >
                Record payment
              </button>
            </div>
            <div className="mt-3 flex fle-row items-center space-x-1 ">
              <div className="p-1.5 rounded-md hover:bg-gray-200 active:bg-gray-100 cursor-pointer">
                <ImAttachment className="h-[20px] w-[20px] flex-shrink-0 text-gray-600" />
              </div>

              <div
                className="p-1.5 rounded-md hover:bg-gray-200 active:bg-gray-100 cursor-pointer"
                onClick={handleDownloadPdf}
              >
                <FaFilePdf  className="h-[20px] w-[20px] flex-shrink-0 text-gray-600" />
              </div>

              {/* Print button */}
              <div
                className="p-1.5 rounded-md hover:bg-gray-200 active:bg-gray-100 cursor-pointer"
                onClick={handlePrint}
              >
                <IoPrintSharp className="h-[23px] w-[23px] flex-shrink-0 text-gray-600" />
              </div>
              <div className="p-1.5 rounded-md hover:bg-gray-200 active:bg-gray-100 cursor-pointer">
                <MdEdit onClick={()=>  editCurrentInvoice()} className="h-[23px] w-[23px] flex-shrink-0 text-gray-600" />
              </div>
              <div className="p-1.5 rounded-md hover:bg-gray-200 active:bg-gray-100 cursor-pointer">
                <MdDelete onClick={()=> deleteInvoice()} className="h-[23px] w-[23px] flex-shrink-0 text-gray-600" />
              </div>
            </div>
          </div>
        </section>

        <section className="mt-4 lg:flex space-x-1">
          {/* Sidebar */}
          <div className="lg:w-[210px]">
            <InvoiceScroll
              onSelection={onSelection}
              viewItemDetails={viewItemDetails}
            ></InvoiceScroll>
          </div>

          {/* Main content area */}
          <section className="w-full overflow-x-hidden mt-4 lg:mt-0 lg:pl-4">
            <section className="w-full">
              {/* Payments Received table - this will NOT be printed because it's outside .print-invoice */}
              <div className="mt-2 border-[1px] border-gray-200 rounded-lg bg-white p-3 lg:p-4">
                <div className="font-bold">
                  {" "}
                  Payments Received (
                  {invoice?.payment_details?.length
                    ? invoice?.payment_details?.length
                    : 0}
                  ){" "}
                </div>
                <InvoicePaymentTable
                  tableData={invoice?.payment_details}
                  viewPaymentRecord={viewPaymentRecord}
                ></InvoicePaymentTable>
              </div>

              {/* Main Invoice Details - this is what we want to print */}
              <div
                ref={invoiceDetailsRef}
                className="mt-4 border-[1px] border-gray-200 rounded-lg bg-white p-4 print-invoice"
              >
                <div>
                  <div>
                    <div>
                      <span>Invoice ID : {invoice?.Invoice_Ref_No} </span>
                    </div>
                    <div>
                      <span>
                        <i className="text-sm font-medium text-primary">
                          Invoice Number:{invoice?.Invoice_No}{" "}
                        </i>
                      </span>
                    </div>
                  </div>

                  <div className="my-2 ">
                    <span>Balance Due</span>
                    <span className=" font-bold ml-1">
                      <CurrencyFormat
                        value={parseFloat(invoice?.Invoice_Amount)?.toFixed(
                          2
                        )}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"₦"}
                      />
                    </span>
                  </div>
                </div>
                <div className="flex justify-end">
                  <StatusBadge
                    statusId={invoice?.Invoice_Status_Id}
                    statusName={invoice?.Invoice_Status_Name}
                    size="md"
                  />
                </div>

                <Grid item xs={12} className="mt-4">
                  <Grid container spacing={10}>
                    <Grid item xs={6}>
                      <div>
                        <div>
                          <span className="#476ef8 font-bold">Delivery Address:</span>{" "}
                          <br></br>
                          <span className="text-sm">
                            <span className=" text-sm">
                              {" "}
                              {invoice?.Customer_Full_Name}
                            </span>{" "}
                            <br />
                            <span className=" text-sm text-capitalize">
                              {" "}
                              {invoice?.Billing_Address1}{" "}
                            </span>
                            <span className=" text-sm text-capitalize">
                              {" "}
                              {invoice?.Billing_Area_Name}{" "}
                            </span>
                            <br />
                            {invoice?.Billing_City_Name}{" "}
                            {invoice?.Billing_Country_Name} <br />
                            {invoice?.Customer_Mobile_No}
                          </span>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={3}>
                      <div>
                        <div>
                          <span className="#476ef8 font-bold">
                            Invoice Date
                          </span>
                          <br></br>
                          <span className="#476ef8 font-bold">Terms</span>
                          <span>
                            {" "}
                            <br></br>
                            <span className="#476ef8 font-bold">Due Date</span>
                          </span>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={3}>
                      <div>
                        <div>
                          <span className="text-sm">
                            {" "}
                            {moment(invoice?.Invoice_Date).format(
                              "DD-MM-YYYY"
                            )}{" "}
                          </span>
                          <br></br>
                          <span className="text-sm">
                            {invoice?.Payment_Term_Name}{" "}
                          </span>
                          <span>
                            {" "}
                            <br></br>
                            <span className="text-sm">
                              {" "}
                              {moment(invoice?.Due_Date).format(
                                "DD-MM-YYYY"
                              )}
                            </span>
                          </span>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                  <span>
                    {" "}
                    <br></br>
                    <span className="text-sm">Pickup Date: </span>
                  </span>
                </Grid>

                <Grid item xs={12}>
                  <InvoiceDetailsTable
                    tableData={invoice["invoice details"]}
                  ></InvoiceDetailsTable>

                  <div className="my-2  ml-[20vw] ">
                    <Grid item xs={12}>
                      <Grid container spacing={2}>
                        <Grid item xs={4}></Grid>

                        <Grid item xs={4}>
                          <div>
                            <div>
                              <span className="#476ef8 font-bold">
                                Sub Total:
                              </span>{" "}
                              <br></br>
                              <span className="text-sm">Discount</span>
                              <span className="text-sm">
                                {" "}
                                <br></br>
                                Shipping Charge
                              </span>{" "}
                              <br></br>
                              <span className="text-sm">Adjustment</span>{" "}
                              <br></br>
                              <span className="h5 font-bold">Total</span>{" "}
                              <br></br>
                              <span className="text-sm font-bold">
                                Payment Made
                              </span>{" "}
                              <br></br>
                            </div>
                          </div>
                        </Grid>
                        <Grid item xs={4}>
                          <div>
                            <div>
                              <span className="#476ef8 ">
                                <CurrencyFormat
                                  value={parseFloat(
                                    calculateSubTotal(
                                      invoice["invoice details"]
                                    )
                                  )?.toFixed(2)}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={"₦"}
                                />
                                {}{" "}
                              </span>
                              <br></br>
                              <span className="text-sm">
                                <CurrencyFormat value={parseFloat(   invoice?.Discount_Amount)?.toFixed(2)}
                                  displayType={"text"} thousandSeparator={true}
                                  prefix={(invoice?.Discount_Type_Id === 1) ? '₦' : invoice?.Discount_Type_Name}
                                />
                                {}{" "}
                              </span>
                              <span>
                                {" "}
                                <br></br>
                                <span className="text-sm">
                                  <CurrencyFormat
                                    value={parseFloat(
                                      invoice?.Shipping_Amount
                                    )?.toFixed(2)}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    prefix={"₦"}
                                  />
                                </span>
                              </span>
                              <br></br>
                              <span>
                                <span className="text-sm">
                                  <CurrencyFormat
                                    value={parseFloat(
                                      invoice?.Adjustment_Amount
                                    )?.toFixed(2)}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    prefix={"₦"}
                                  />
                                </span>
                              </span>
                              <br></br>
                              <span className="h5 font-bold">
                                <CurrencyFormat
                                  value={parseFloat(
                                    calculateGrandTotal(
                                      invoice["invoice details"]
                                    )
                                  )?.toFixed(2)}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={"₦"}
                                />
                              </span>
                              <br></br>
                              <span
                                style={{ color: "#F17E7E" }}
                                className="text-sm"
                              >
                                <CurrencyFormat
                                  className=" font-bold"
                                  value={parseFloat(
                                    calculatePayment(
                                      invoice["payment_details"]
                                    )
                                  )?.toFixed(2)}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={"₦"}
                                />
                              </span>
                            </div>
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                  </div>
                  {/*file  */}
                  <div className="text-center" >
                    {(invoice?.Attachement_URL?.length > 3) && 
                      <a key={invoice?.Attachement_URL} href={`${invoice?.Attachement_URL}`} className='btn btn-primary'  target="_blank" rel="noopener noreferrer">
                        Open File
                      </a>
                    }
                  </div>

                  <div className="mt-4 ">
                    <span className="font-bold">Notes</span>
                    <p className="text-sm text-gray-600">
                      Please send an email to accounts@worldbaytech.com or call
                      08099346131 if you have any questions concerning this
                      invoice. Looking forward to your business.
                    </p>
                  </div>
                </Grid>
              </div>
            </section>
          </section>
        </section>
      </section>
    </>
  );
};

export default InvoiceDetailsPage;